<template>
  <b-modal
    id="emitted-notification-id"
    body-class="p-0"
    :visible="shallShowEmittedNotificationModal"
    :size="$store.getters['app/currentBreakPoint'] !== 'xl' ? 'lg' : $store.getters['app/currentBreakPoint']"
    :hide-footer="!notificaciones.length && !showLoader"
    @change="(val) => $emit('update:show-emitted-notification-modal', val)"
  >
    <!-- Modal Header -->
    <template #modal-header>
      <!-- Título -->
      <h5 class="modal-title">
        Notificaciones emitidas
      </h5>

      <!-- Acciones de modal -->
      <div class="modal-actions d-inline">
        <div>
          <!-- Cerrar -->
          <span
            v-b-tooltip.hover="'Cerrar'"
            class="bullet bullet-danger cursor-pointer"
            @click="selected = {}; $emit('update:show-emitted-notification-modal', false)"
          />
        </div>
      </div>
    </template>

    <!-- Modal Footer -->
    <template #modal-footer>
      <b-skeleton-wrapper :loading="showLoader">
        <!-- Loader -->
        <template #loading>
          <b-skeleton type="button" />
        </template>
        <!-- Paginación -->
        <b-pagination
          v-model="currentPage"
          :total-rows="notificaciones.length"
          :per-page="perPage"
          hide-goto-end-buttons
          class="mb-0"
          align="right"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-skeleton-wrapper>
    </template>

    <!-- Cuantos elementos ver por página -->
    <div class="m-2">
      <b-skeleton-wrapper :loading="showLoader">
        <!-- Loader -->
        <template #loading>
          <b-skeleton type="button" />
        </template>
        <!-- Cuantos elementos ver por página (dropdown) -->
        <b-dropdown
          v-if="notificaciones.length"
          :text="`Mostrando ${perPage}`"
          size="sm"
          right
          variant="primary"
          class="dropdown-icon-wrapper"
        >
          <b-dropdown-item
            v-for="toShow in [5, 10, 20, 50]"
            :key="toShow"
            @click="perPage = toShow"
          >
            <span>{{ toShow }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </b-skeleton-wrapper>
    </div>

    <!-- Notification list and detail -->
    <section class="m-2">
      <!-- Notificaciones y detalle -->
      <b-row>
        <!-- Lista -->
        <b-col
          xl="7"
          lg="6"
          md="12"
        >
          <b-skeleton-wrapper :loading="showLoader">
            <!-- Loader -->
            <template #loading>
              <b-skeleton
                width="100%"
                height="5em"
              />
              <b-skeleton
                width="100%"
                height="5em"
              />
              <b-skeleton
                width="100%"
                height="5em"
              />
            </template>
            <!-- Lista de notificaciones -->
            <emmited-notification-list
              v-for="data in paginateItems"
              :key="data.idNotificacion"
              :item="data"
              :notification-selected.sync="selected"
            />
          </b-skeleton-wrapper>
        </b-col>
        <!-- Detalle -->
        <b-col
          xl="5"
          lg="6"
          md="12"
        >
          <b-skeleton-wrapper :loading="showLoader">
            <!-- Loader -->
            <template #loading>
              <b-skeleton
                width="100%"
                height="5em"
              />
            </template>
            <!-- Detalle de notificación seleccionada -->
            <hr class="mb-2 d-block d-lg-none">
            <emmited-notification-detail
              v-if="notificaciones.length && !showLoader"
              :item="selected"
            />
          </b-skeleton-wrapper>
        </b-col>
      </b-row>
      <!-- No ha emitido notificaciones -->
      <b-row v-if="!notificaciones.length && !showLoader">
        <b-col
          cols="12"
          class="text-center"
        >
          <span
            class="mb-75"
          >
            No ha emitido notificaciones hasta este momento.
          </span>
        </b-col>
      </b-row>
    </section>

  </b-modal>
</template>

<script>
import {
  VBTooltip,
  BPagination,
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
  BSkeletonWrapper,
  BSkeleton,
} from 'bootstrap-vue'
import { formhttp, paginateArray } from '@core/utils/utils'
import { getData } from '@core/utils/http/general'
import store from '@/store'
import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import EmmitedNotificationList from './components/EmmitedNotificationList.vue'
import EmmitedNotificationDetail from './components/EmmitedNotificationDetail.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BPagination,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BSkeletonWrapper,
    BSkeleton,

    EmmitedNotificationList,
    EmmitedNotificationDetail,
  },
  model: {
    prop: 'shallShowEmittedNotificationModal',
    event: 'update:show-emitted-notification-modal',
  },
  props: {
    shallShowEmittedNotificationModal: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const toast = useToast()
    const showLoader = ref(false)
    const selected = ref({})
    const notificaciones = ref([])
    const currentPage = ref(1)
    const perPage = ref(5)

    const paginateItems = computed(() => paginateArray(notificaciones.value, perPage.value, currentPage.value))

    const getNotifications = () => {
      const { token } = store.state.cuenta.session
      const { id } = store.state.cuenta.rolSelected
      selected.value = {}

      showLoader.value = true
      getData({ action: 4, x: id, token }, 'wsnotificacion')
        .then(response => {
          showLoader.value = false
          const { label } = formhttp(response.status)

          if (response.status !== 200) {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Notificaciones',
                text: response.message,
                icon: 'BellIcon',
                variant: label,
              },
            },
            { timeout: 8000 })
          }

          notificaciones.value = response.data.data || []
        })
        .catch(error => {
          showLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando notificaciones',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    watch(() => props.shallShowEmittedNotificationModal, status => { if (status) getNotifications() })

    return {
      // Data
      notificaciones,
      selected,
      paginateItems,

      // Methods
      getNotifications,

      // Loader
      showLoader,

      // Pagination
      currentPage,
      perPage,
    }
  },
}
</script>
